import { render, staticRenderFns } from "./WidgetEditorView.vue?vue&type=template&id=693c5520&scoped=true&"
import script from "./WidgetEditorView.vue?vue&type=script&lang=js&"
export * from "./WidgetEditorView.vue?vue&type=script&lang=js&"
import style0 from "./WidgetEditorView.vue?vue&type=style&index=0&id=693c5520&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693c5520",
  null
  
)

export default component.exports